var render = function render(){var _vm=this,_c=_vm._self._c;return _c('echarts-com',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"parkingDensity-peopleFlow","options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }